<template>
  <div class="clock" v-pageBuried data-page-buried="BG_NAOZHONGZY">
    <AppNavBar
      title="我的营养闹钟"
      :placeholder="true"
      :options="options"
      :z-index="1000"
    >
      <template slot="right">
        <div
          class="list-icon iconfont icon-category"
          @click="bindToPlanList"
        ></div>
      </template>
    </AppNavBar>
    <div class="container">
      <ActivityBar :data="activityInfo" style="margin-top: 12px" />
      <div class="clock-container">
        <ClockComponent v-if="planData" @edit="bindEditPlan" :data="planData" />
      </div>
      <div class="plan-container">
        <div class="plan-padding">
          <div class="plan-top">
            <div class="plan-title">{{ planData.plan_title }}</div>
          </div>
          <!--   <div class="plan-tips">
                        <span class="warn iconfont icon-warning-fill"></span>
                        <span class="tips-text">当前计划存在生物素超量风险</span>
                        <span class="iconfont icon-you"></span>
                    </div> -->
          <div class="plan-list">
            <div
              class="plan-item"
              v-for="(item, index) in planData.renderList"
              :key="index"
              :class="{ 'plan-item-disabled': !item.canEat }"
            >
              <div class="p-item-left">
                <div class="p-item-dot"></div>
                <div class="p-item-dashed"></div>
              </div>
              <div class="p-item-right">
                <div class="p-item-time"
                  >{{ item.eat_hour | filterTimeFillZero }}:{{
                    item.eat_minute | filterTimeFillZero
                  }}</div
                >
                <div class="p-item-list">
                  <div
                    class="p-item-list-item"
                    v-for="(item1, index1) in item.list"
                    :key="index1"
                    @click="bindClickTonicItem(item1)"
                  >
                    <img class="p-item-image" :src="item1.p_image" alt="" />
                    <div class="p-item-b-center">
                      <div class="p-item-name">{{ item1.p_title }}</div>
                      <div class="p-item-info">
                        <img
                          class="p-item-brand"
                          :src="item1.brand_img"
                          alt=""
                        />
                        <div class="p-item-desc"
                          >{{ item1.every_times_num
                          }}{{ item1.min_unit_txt }}·{{
                            item1.take_suggested_time_txt
                          }}</div
                        >
                      </div>
                    </div>
                    <div class="p-item-b-right">
                      <div class="btn-1" v-if="item1.is_eat"
                        ><span
                          >{{ item1.record_hour | filterTimeFillZero }}:{{
                            item1.record_minute | filterTimeFillZero
                          }}</span
                        ><span class="iconfont icon-gou"></span
                      ></div>
                      <div
                        class="btn-2"
                        v-else-if="!item1.is_eat && item.canEat"
                        @click.stop="bindEatTonic(item1)"
                        >我吃过了</div
                      >
                      <div
                        class="btn-3"
                        v-else-if="!item1.is_eat && !item.canEat"
                        >未到时</div
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 推荐方案 -->
          <div
            class="recommend-container"
            v-if="recommendPlan && recommendPlan.length"
          >
            <div class="recommend-title">
              <div class="item-line line-before"></div>
              <div class="item-dot"></div>
              <div class="item-title">推荐完整方案</div>
              <div class="item-dot"></div>
              <div class="item-line line-after"></div>
            </div>
            <div class="recommend-plan-list">
              <div
                class="recommend-plan-item"
                v-for="(item, index) in recommendPlan"
                :key="index"
                v-buried
                :data-buried="'BG_NAOZHONGZY_TUIJIANJIHUA_' + item.template_id"
                v-clickBuried
                :data-click-buried="
                  'CLICK_NAOZHONGZY_TUIJIANJIHUA_' + item.template_id
                "
                @click="bindClickRecommendPlan(item)"
              >
                <img class="r-item-icon" :src="item.sub_cover_image" alt="" />
                <div class="r-item-center">
                  <div class="r-item-name">{{ item.title }}</div>
                  <div
                    class="r-item-desc"
                    v-if="item.mate_tonic_list && item.mate_tonic_list.length"
                  >
                    提到了您正在服用的<span
                      v-for="(item1, index1) in item.mate_tonic_list"
                      :key="index1"
                      >{{ item1.title
                      }}<span v-if="index1 < item.mate_tonic_list.length - 1"
                        >、</span
                      ></span
                    ></div
                  >
                  <div class="r-item-use"
                    >{{ item.eat_count || 0 }}人正在使用</div
                  >
                </div>
                <div class="r-item-iconfont iconfont icon-you"></div>
              </div>
            </div>
          </div>
          <!-- 建议 -->
          <!-- <div class="recommendation">

                        <div class="recommendation-title">{{ planData.incoming_title }}</div>
                        <div class="recommendation-text">{{ planData.incoming_line }}</div>
                    </div> -->
        </div>
        <!-- <div class="consult-container" v-buried data-buried="BG_NAOZHONGZY_JINXIAN" v-clickBuried
                    data-click-buried="CLICK_NAOZHONGZY_JINXIAN">
                    <img class="avatar"
                        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/62b4797642caef23d24cd8f1cdd47530.jpg" alt="">
                    <div class="con-center">
                        <div class="con-desc">国家注册营养师</div>
                        <div class="con-name">李玲</div>
                    </div>
                    <div class="con-right" @click="bindConsult">
                        <span>更多问题咨询</span>
                        <span class="iconfont icon-you"></span>
                    </div>
                </div> -->
      </div>
      <ClockToast
        v-model="showClockToast"
        :data="clockToastData"
        @confirm="bindDefaultConfirm"
        :id="(planData && planData.template_id) || 0"
      />
      <van-popup v-model="showTonicDetail" position="bottom" round>
        <TonicDetail :id="tonicId" v-if="showTonicDetail" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { jumpToMiniProgram } from '../data.js'
import AppNavBar from '@/components/app/nav-bar/index.vue'
import ClockComponent from './clock-ui.vue'
import ClockToast from './clock-toast.vue'
import { deepClone } from '@/common/common.js'
import TonicDetail from './tonic-detail.vue'
import ActivityBar from './activity-bar.vue'
export default {
  components: {
    AppNavBar,
    ClockComponent,
    ClockToast,
    TonicDetail,
    ActivityBar
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)',
        color: 'rgba(0,0,0,0.8)'
      },
      planData: null,
      recommendPlan: [],
      showClockToast: false,
      clockToastData: null,
      showTonicDetail: false,
      tonicId: 0,
      activityInfo: null
    }
  },
  filters: {
    filterTimeFillZero(time) {
      return time > 9 ? time : '0' + time
    }
  },
  watch: {
    data() {
      this.init()
    }
  },
  created() {
    this.init()
    this.getRecommendPlanByTonicId()
    this.getConfigData()
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    bindClickTonicItem(item) {
      this.tonicId = item.product_id
      this.showTonicDetail = true
    },
    async getConfigData() {
      let params = {}
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/config', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityInfo = res.data.activity_config
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindToPlanList() {
      this.$router.push({
        path: '/nutrition-clock/plan-list',
        query: {}
      })
    },
    bindConsult() {
      jumpToMiniProgram()
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindClickRecommendPlan(item) {
      this.$router.push({
        path: '/nutrition-clock/plan-detail',
        query: {
          id: item.template_id,
          status: 1,
          planType: 2
        }
      })
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset
      if (scrollTop >= 100) {
        this.options = {
          barBackgroundColor: '#fff',
          color: 'rgba(0,0,0.8)'
        }
      } else {
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(0,0,0.8)'
        }
      }
    },
    init() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.planData = this.dealPlanData(deepClone(this.data))
      this.$store.commit('nutritionClock/setPlanData', this.planData)
      this.timer = setInterval(() => {
        this.updateClockData()
      }, 1000)
    },
    updateClockData() {
      this.planData.serverTime++
      this.planData = this.dealPlanData(this.planData)
    },
    /* 根据服务器时间获取圆环当前角度 */
    getAngle(time) {
      let now = time
      let zero = new Date(new Date(time).toLocaleDateString()).getTime() //今天凌晨0点
      let totalAngle = 360
      return parseInt(((now - zero) / (1000 * 60 * 60 * 24)) * totalAngle)
    },
    /* 处理后端返回的数据 */
    dealPlanData(data) {
      if (data.list && data.list.length) {
        data._serverTime = data.serverTime
        let timeObj = {} //缓存时分对象
        data.list.map((item) => {
          let canEatTime = new Date(data.serverTime * 1000).setHours(
            item.eat_hour,
            item.eat_minute,
            0,
            0
          )
          let curTime = new Date(data.serverTime * 1000)
          item.canEat = curTime >= canEatTime
          if (timeObj[item.eat_hour + '_' + item.eat_minute]) {
            timeObj[item.eat_hour + '_' + item.eat_minute].list.push(item)
          } else {
            let angle = this.getAngle(
              new Date().setHours(item.eat_hour, item.eat_minute, 0, 0)
            )
            timeObj[item.eat_hour + '_' + item.eat_minute] = {
              canEat: item.canEat,
              eat_minute: item.eat_minute,
              eat_hour: item.eat_hour,
              angle: angle,
              left: this.getTonicPosition(angle, 'left'),
              top: this.getTonicPosition(angle, 'top'),
              list: [item]
            }
          }
        })
        let res = Object.keys(timeObj).map((item) => {
          return timeObj[item]
        })
        let isFindNotEat = false
        res.map((item) => {
          let isEatList = item.list.filter((item1) => {
            return item1.is_eat
          })
          item.isEat = isEatList.length == item.list.length
          if (!isFindNotEat && !item.canEat) {
            isFindNotEat = true
            item.isSwipe = true
          } else {
            item.isSwipe = false
          }
        })
        if (!isFindNotEat) {
          res[0].isSwipe = true
        }
        data.renderList = res
        data.clockData = {
          angle: this.getAngle(data.serverTime * 1000),
          time: this.getTimeOut(data.serverTime, data.renderList)
        }
        /* 轮播图 当存在不能吃的时间段则优先取，没有则取第一个 */
        data.curSwiperData = data.renderList.length
          ? data.renderList.find((item) => {
              return item.canEat == false
            }) || data.renderList[0]
          : null
      } else {
        data.clockData = {
          angle: 0,
          time: ''
        }
        data.curSwiperData = null
      }
      return data
    },
    getTonicPosition(angle, type) {
      if (type == 'left') {
        let left =
          0.5 +
          0.5 *
            parseFloat(
              (1 - 0.06) * Math.sin(2 * Math.PI * (angle / 360)).toFixed(2)
            )
        return +left.toFixed(2)
      } else if (type == 'top') {
        let top =
          0.5 -
          0.5 *
            parseFloat(
              (1 - 0.06) * Math.cos(2 * Math.PI * (angle / 360)).toFixed(2)
            )
        return +top.toFixed(2)
      }
    },
    /* 获取倒计时 参数 当前时间,计划列表*/
    getTimeOut(time, list) {
      if (!list.length) {
        return 0
      }
      let curTime = new Date(time * 1000).getTime()
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        let planTime = new Date(time * 1000).setHours(
          item.eat_hour,
          item.eat_minute,
          0,
          0
        )
        if (planTime > curTime) {
          return (planTime - curTime) / 1000
        }
      }
      /* 如果当前时间比任何计划时间大时 */
      let nextItem = list[list.length - 1]
      let nexTime = new Date(time * 1000 + 24 * 60 * 60 * 1000).setHours(
        nextItem.eat_hour,
        nextItem.eat_minute,
        0,
        0
      )
      return (nexTime - curTime) / 1000
    },
    /* 通过补剂id获取推荐计划 */
    async getRecommendPlanByTonicId() {
      if (this.data.type != 1) {
        return
      }
      let tonicIds = this.data.list.map((item) => {
        return item.product_id
      })
      tonicIds = Array.from(new Set(tonicIds))
      let params = {
        tonic_ids: tonicIds || []
      }
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/getCompletePlanByTonic', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.recommendPlan = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindEditPlan() {
      this.$router.push({
        path: '/nutrition-clock/edit-plan',
        query: {
          type: this.planData.type
        }
      })
    },
    bindEatTonic(item) {
      this.clockToastData = item
      this.showClockToast = true
    },
    bindDefaultConfirm() {
      this.showClockToast = false
      this.addTonicRecord(this.clockToastData)
    },
    async addTonicRecord(item) {
      let params = {
        usage_time_id: item.t_id, //服用时间主键id,
        plan_id: this.planData.plan_id
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/addTonicRecord', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('🎉健康+1')
          this.$parent.getPlanData()
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.clock {
  background-color: rgba(249, 249, 249, 1);
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/895d84cca28432a8b06c7d27a2aaab21.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  z-index: 1;

  .list-icon {
    font-size: 24px;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    padding-bottom: 30px;

    .clock-container {
      position: relative;
      z-index: 1;
      width: 100%;
    }

    .plan-container {
      position: relative;
      z-index: 2;
      width: 343px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;

      .plan-padding {
        padding: 14px 16px 12px;
      }

      .plan-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 18px;

        .plan-title {
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 25px;
        }

        .plan-record {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }
      }

      .plan-tips {
        margin-bottom: 8px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #fc4444;
        line-height: 17px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        height: 28px;
        background: #fff0f0;
        border-radius: 8px;

        .warn {
          margin-right: 10px;
        }

        .tips-text {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }
      }

      .plan-list {
        margin-bottom: 35px;

        .plan-item {
          display: flex;
          align-items: stretch;

          .p-item-left {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-right: 7px;

            .p-item-dot {
              width: 8px;
              height: 8px;
              background: #03d4e6;
              border-radius: 50%;
            }

            .p-item-dashed {
              margin-top: 4px;
              margin-bottom: 2px;
              width: 1px;
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              border-right: 1px dashed rgba(0, 0, 0, 0.15);
            }
          }

          .p-item-right {
            padding-bottom: 20px;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;

            .p-item-time {
              font-size: 18px;
              font-family: DINPro, DIN;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 23px;
              margin-bottom: 10px;
            }

            .p-item-list {
              .p-item-list-item {
                display: flex;
                align-items: center;
                margin-bottom: 16px;

                .p-item-image {
                  object-fit: contain;
                  width: 40px;
                  height: 40px;
                  background: #f7fae7;
                  border-radius: 6px;
                  margin-right: 8px;
                }

                .p-item-b-center {
                  flex: 1;
                  flex-shrink: 0;
                  overflow: hidden;
                  margin-right: 10px;

                  .p-item-name {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    font-size: 13px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.8);
                    line-height: 18px;
                    min-height: 18px;
                    margin-bottom: 5px;
                  }

                  .p-item-info {
                    display: flex;
                    align-items: center;

                    .p-item-brand {
                      object-fit: contain;
                      box-sizing: border-box;
                      width: 40px;
                      height: 14px;
                      box-sizing: border-box;
                      border: 0.5px solid #dddddd;
                      border-radius: 2px;
                      margin-right: 6px;
                    }

                    .p-item-desc {
                      font-size: 11px;
                      font-family: PingFangSC, PingFang SC;
                      color: rgba(0, 0, 0, 0.5);
                      line-height: 16px;
                    }
                  }
                }

                .p-item-b-right {
                  min-width: 73px;

                  .btn-1 {
                    width: 73px;
                    height: 30px;
                    background: rgba(3, 212, 230, 0.1);
                    border-radius: 15px;
                    font-size: 13px;
                    font-family: DINPro, DIN;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #00cddf;
                    .iconfont {
                      margin-left: 6px;
                      font-size: 12px;
                    }
                  }

                  .btn-2 {
                    width: 73px;
                    height: 30px;
                    background: #03d4e6;
                    font-family: PingFangSC, PingFang SC;
                    border-radius: 15px;
                    font-size: 13px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                  }

                  .btn-3 {
                    width: 73px;
                    height: 30px;
                    font-size: 13px;
                    font-family: PingFangSC, PingFang SC;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: rgba(0, 0, 0, 0.5);
                  }
                }
              }

              .p-item-list-item:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .plan-item:last-child {
          .p-item-right {
            padding-bottom: 0;
          }
        }

        .plan-item-disabled {
          .p-item-left {
            .p-item-dot {
              background: #c9c9c9;
            }
          }

          .p-item-right {
            .p-item-time {
              color: rgb(178, 178, 178);
            }
          }
        }
      }

      .recommend-container {
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);

        .recommend-title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
          margin-bottom: 10px;

          .item-title {
            margin: 0 12px;
          }

          .item-line {
            width: 40px;
            height: 1px;
            background: linear-gradient(
              90deg,
              rgba(52, 49, 79, 0.15) 0%,
              rgba(52, 49, 79, 0) 100%
            );
          }

          .item-dot {
            width: 4px;
            height: 4px;
            transform: rotate(45deg);
            background: rgba(226, 225, 229, 01);
          }

          .line-before {
            margin-right: -2px;
            transform: rotate(180deg);
          }

          .line-after {
            margin-left: -2px;
          }
        }

        .recommend-plan-list {
          .recommend-plan-item {
            background: #f5f5f5;
            border-radius: 8px;
            padding: 12px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .r-item-icon {
              object-fit: cover;
              width: 54px;
              height: 54px;
              border-radius: 6px;
              margin-right: 10px;
            }

            .r-item-center {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              margin-right: 10px;
              font-size: 10px;
              font-family: PingFangSC, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 14px;

              .r-item-name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                color: rgba(0, 0, 0, 0.8);
                line-height: 17px;
                margin-bottom: 3px;
              }

              .r-item-desc {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .r-item-use {
                margin-top: 6px;
              }
            }

            .r-item-iconfont {
              color: rgba(52, 49, 79, 0.8);
            }
          }

          .recommend-plan-item:last-child {
            margin-bottom: 0;
          }
        }
      }

      .recommendation {
        padding: 16px 0px 0px;

        .recommendation-title {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-bottom: 6px;
        }

        .recommendation-text {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
          word-break: break-all;
        }
      }
    }

    .consult-container {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      background: linear-gradient(270deg, #88c4dc 0%, #84a9bd 100%);
      position: relative;

      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 9px;
      }

      .con-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        color: #ffffff;
        line-height: 14px;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;

        .con-desc {
          margin-bottom: 4px;
        }

        .con-name {
          font-size: 14px;
        }
      }

      .con-right {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        align-items: center;

        .iconfont {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #ffffff;
          margin-left: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(165, 203, 218, 1);
          font-size: 12px;
        }
      }
    }

    .consult-container::after {
      content: '';
      position: absolute;
      left: 46px;
      top: -6px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 0px solid transparent;
      border-right: 8px solid #fff;
      transform: rotate(45deg);
    }
  }
}
</style>
